/**
 * RFC 4180-style CSV field encoding: wrap in quotes if the value contains a comma,
 * double-quote, or line break; escape " as "".
 */
const NEEDS_QUOTE = /[",\r\n\u2028\u2029]/;

export function escapeCsvCell(value: unknown): string {
  const s = value == null ? "" : String(value);
  if (!NEEDS_QUOTE.test(s)) return s;
  return `"${s.replace(/"/g, '""')}"`;
}

export function joinCsvRow(cells: readonly unknown[]): string {
  return cells.map((c) => escapeCsvCell(c)).join(",");
}
